export const SET_MESSAGE = 'SET_MESSAGE';
export const HIDE_MESSAGE = 'HIDE_MESSAGE';
export const SET_SECTION = 'SET_SECTION';
